export default __webpack_public_path__ + "static/media/learningOutcomesTick.108a7d45.svg";